import React, { Suspense } from 'react';
import { hot } from 'react-hot-loader/root';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { /*ProtectedRoute,*/ SwuifApp } from 'swuif';
import { app } from '@/config';
// import Auth from '@/routes/Auth';
// import Main from '@/routes/Main';
import '@/style/index.less';
import '@/style/app.less';
import S2u from '@/routes/Main/Store2u/Store2u';
import PageNotFound from '@/routes/Main/Store2u/Page404';
import Spp from '@/routes/Main/Spp/Spp';
import SppResultVoucher from '@/routes/Main/Spp/SppResultVoucher';
import ContactService from '@/routes/Main/ContactService/ContactService';
import ContactServiceNoTitle from '@/routes/Main/ContactService/ContactServiceNoTitle';

const App = () => {
  return (
    <SwuifApp {...app}>
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <Route exact strict path="/s2u/:data" component={S2u} />
            <Route exact strict path="/spp" component={Spp} />
            <Route
              exact
              strict
              path="/spp/result_voucher/"
              component={SppResultVoucher}
            />
            <Route
              exact
              strict
              path="/contact-service"
              component={ContactService}
            />
            <Route
              exact
              strict
              path="/contact-service-nt"
              component={ContactServiceNoTitle}
            />
            <Route exact strict component={PageNotFound} />
            {/* <Route strict path="/auth" component={Auth} /> */}
            {/* <ProtectedRoute
              strict
              path="/"
              redirect={{ to: '/auth/login' }}
              component={Main}
            /> */}
          </Switch>
        </Suspense>
      </BrowserRouter>
    </SwuifApp>
  );
};

export default hot(App);
